import ecsProductDefault from '@assets/images/ecs-product-default.jpeg';

export const DEFAULT_IMAGE = ecsProductDefault;
